import React from "react";
import { ParsedText } from "../../utils/ParsedText";
import { Link } from "./Link";

export function Message({
    from,
    children,
    icon,
    linkPart,
    handleLinkClick,
    getLocalization,
}: {
    from: "character" | "you" | "guest";
    children: string;
    icon?: string;
    linkPart?: {
        type: "link";
        url: string;
        label: string;
    };
    handleLinkClick: (cta: InboxCTA) => void;
    getLocalization: (id: string) => string;
}) {
    return (
        <div
            className={`message from-${from} ${icon ? `character-${icon}` : ""} ${linkPart !== undefined ? "with-suffix" : ""}`}
        >
            <ParsedText animate>{children}</ParsedText>
            {linkPart !== undefined && (
                <Link
                    handleClick={() => {
                        handleLinkClick({
                            id: linkPart.url,
                            label: linkPart.label,
                            type: "url",
                            url: linkPart.url,
                            variant: "red",
                            functionName: "",
                            functionArgs: [],
                        });
                    }}
                >
                    {getLocalization("globalText.langWatch")}
                </Link>
            )}
        </div>
    );
}
